(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function validateFormJoinTheTribe () {
    const handleValidateForm = () => {
      const errorMessage = document.querySelector('.join-the-tribe-wrapper .error-message');
      const form = document.querySelector('.join-the-tribe-wrapper form');
      const btnForm = document.querySelector('.join-the-tribe-wrapper button[type="button"]');
      
      const validateEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
      
      const filedFirstName = document.querySelector('#first_name_50245235');
      const filedLastName = document.querySelector('#last_name_50245236');
      const filedEmail = document.querySelector('#email_50245237');
      const mesErrorFooter = document.querySelectorAll('.mes-error-footer');
      let hasError = false;

      if (mesErrorFooter.length) {
        mesErrorFooter.forEach(mesError => mesError.remove());
      }

      if (filedFirstName.value == '') {
        filedFirstName.classList.add('error-style');
        let errorFirstname = document.createElement('p');
        errorFirstname.classList.add('mes-error-footer');
        errorFirstname.innerText = 'First name field cannot be empty';
        errorFirstname.style.color = '#bd472a';
        filedFirstName.parentElement.style.alignSelf = 'flex-start';
        filedFirstName.parentElement.appendChild(errorFirstname);
        hasError = true;
      }
      if (filedLastName.value == '') {
        filedLastName.classList.add('error-style');
        let errorLastname = document.createElement('p');
        errorLastname.classList.add('mes-error-footer');
        errorLastname.style.color = '#bd472a';
        errorLastname.innerText = 'Last name field cannot be empty';
        filedLastName.parentElement.style.alignSelf = 'flex-start';
        filedLastName.parentElement.appendChild(errorLastname);
        hasError = true;
      }
      if (filedEmail.value == '') {
        filedEmail.classList.add('error-style');
        let errorEmailEmpty = document.createElement('p');
        errorEmailEmpty.classList.add('mes-error-footer');
        errorEmailEmpty.style.color = '#bd472a';
        errorEmailEmpty.innerText = 'Email field cannot be empty';
        filedEmail.parentElement.style.alignSelf = 'flex-start';
        filedEmail.parentElement.appendChild(errorEmailEmpty);
        hasError = true;
      }
      if (filedEmail.value != '' && !validateEmail(filedEmail.value)) {
        filedEmail.classList.add('error-style');
        let errorEmailNotFormat = document.createElement('p');
        errorEmailNotFormat.classList.add('mes-error-footer');
        errorEmailNotFormat.style.color = '#bd472a';
        errorEmailNotFormat.innerText = 'Please enter a valid email address.';
        filedEmail.parentElement.style.alignSelf = 'flex-start';
        filedEmail.parentElement.appendChild(errorEmailNotFormat);
        hasError = true;
      } 
      if (hasError != true) {
        form.classList.add('submited');
        filedEmail.classList.remove('error-style');
        errorMessage.innerHTML = '';
        if (window.innerWidth > 450) {
          setTimeout(() => {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'S7hiWG']);
          }, 3000);
        }
      }
    }
    
    const f = setInterval(() => { 
      const form = document.querySelector('.join-the-tribe-wrapper form');
      const btnForm = document.querySelector('.join-the-tribe-wrapper button[type="button"]');
      
      if (form && btnForm) {
        clearInterval(f);
        clearTimeout(clear);
        form.addEventListener('submit', () => {
          handleValidateForm();
        });
        btnForm.addEventListener('click', () => {
          handleValidateForm();
        });
      }
    }, 200);

    const clear = setTimeout(() => {
      clearInterval(f);
    }, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reference"]) return;
  try {
    
  $(document).ready(function () {
    $('.reference-body').hide();
    $('.reference-header').click(function () {
      if (this.className.indexOf('expanded') > -1) {
        $(this).removeClass('expanded');
      } else {
        $(this).addClass('expanded');
      }
      $(this).next('.reference-body').slideToggle();

      $('.reference-body').not($(this).next()).slideUp();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-info-boxes"] && !window.DesignMode) return;
  try {
     

  function e() {
    var wsy = window.scrollY;
    document.querySelectorAll('.info-boxex-main').forEach(function (e) {
      var o = e.offsetTop - 400;
      var n = wsy - o;
      var r = e.querySelector('.feel-alive');
      r.style.right = `${n}px`;
    });
  }
  window.addEventListener('load', e);
  window.addEventListener('resize', e);
  window.addEventListener('scroll', e);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-main-blog"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var endlessScroll = new Ajaxinate({
      container: '#BlogsAjaxinateLoop',
      pagination: '#BlogAjaxinatePagination',
    });
  });

  // Toggle the dropdown menu open and closed
  (function ($) {
    const dropdownToggle = $('.category-dropdown');
    let list = dropdownToggle.children('.dropdown-menu');
    list.data('height', list.height());
    list.css('height', 0);
    list.data('cheight', 0);
    list.hide();

    dropdownToggle.on('click', function () {
      let list = dropdownToggle.children('.dropdown-menu');
      dropdownToggle.toggleClass('show');
      let height = list.data('height');
      let cheight = list.data('cheight');
      if (cheight == 0) {
        list.css('height', `${height}px`);
        list.data('cheight', height);
      } else {
        list.css('height', 0);
        list.data('cheight', 0);
      }
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-carousel"] && !window.DesignMode) return;
  try {
    
  var owl = document.querySelector('.product-carousel');
  owl.owlCarousel({
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
        margin: 25,
      },
      768: {
        items: 2,
        margin: 25,
      },
      1200: {
        items: 3,
        margin: 25,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
